import { LaserTable } from "portal/components/LaserTable";
import { portalApi } from "portal/state/portalApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { useQueryPopups } from "portal/utils/hooks/useApiPopups";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import React, { FunctionComponent } from "react";

const _RobotLasersList: FunctionComponent = () => {
  const { serial } = useParams();

  const { data: hardware } = useQueryPopups(
    portalApi.endpoints.getRobotHardware.useQuery(
      serial ? { serial } : skipToken
    )
  );

  return <LaserTable lasers={hardware?.lasers ?? []} internalSerial={serial} />;
};

export const RobotLasersList = withAuthenticationRequired(_RobotLasersList);
